import { z } from 'zod';
export const syncStatuses = [
    'pending',
    'running',
    'review_required',
    'audit_pending',
    'completed',
    'failed',
    'cancelled',
];
export const syncPhaseStatuses = [
    'pending',
    'running',
    'completed',
    'failed',
    'skipped',
    'cancelled',
];
export const syncFailureReasons = [
    'setup_failed',
    'phase_failed',
    'review_rejected',
    'audit_failed',
    'timeout',
    'cancelled',
    // ocn-S285-P0 — pre-execution security gate blocked the sync because the
    // VettIQ repo scan returned verdict='block' (malicious code, dangerous build
    // hooks, dependency risk, secret exfil, or sandbox-escape attempts), or the
    // scanner was unreachable on an untrusted external repo (fail-closed).
    'security_block',
    // ocn-S287-P0 — distinct from security_block: the scanner itself errored
    // (verdict='error' or 'skipped') rather than finding real malicious content.
    // This is a tool issue (transient, retryable), NOT a problem in user code.
    'security_scanner_error',
    // ocn-S625-P0 — repository has no default branch or no code files to sync.
    'empty_repo',
    // ocn-s1216-p0 — repository has no commits on its default branch.
    'repo_empty',
    'unknown',
];
export const syncStatusSchema = z.enum(syncStatuses);
export const syncPhaseStatusSchema = z.enum(syncPhaseStatuses);
export const syncFailureReasonSchema = z.enum(syncFailureReasons);
export const syncPhaseStateSchema = z.object({
    id: z.string().min(1).max(128),
    name: z.string().min(1).max(256),
    status: syncPhaseStatusSchema,
    started_at: z.string().datetime().optional(),
    completed_at: z.string().datetime().optional(),
    error: z.string().max(4_000).optional(),
    output: z.record(z.unknown()).optional(),
});
export const syncRunPatchSchema = z.object({
    status: syncStatusSchema.optional(),
    current_phase: z.string().min(1).max(128).nullable().optional(),
    phases_json: z.array(syncPhaseStateSchema).optional(),
    review_required: z.boolean().optional(),
    review_approved_at: z.coerce.date().nullable().optional(),
    completed_at: z.coerce.date().nullable().optional(),
    agents_md_diff: z.string().nullable().optional(),
    routing_rules_diff: z.string().nullable().optional(),
    packages_diff: z.string().nullable().optional(),
    error: z.string().max(4_000).nullable().optional(),
    // ocn-S65-P1a — structured failure reason persisted to sync_runs.failure_reason
    failure_reason: syncFailureReasonSchema.nullable().optional(),
    error_class: z.string().min(1).max(256).nullable().optional(),
});
export const syncEventSchema = z.object({
    run_id: z.string().min(1),
    project_id: z.string().min(1),
    status: syncStatusSchema,
    phase: z.string().min(1).max(128).optional(),
    message: z.string().max(2_000).optional(),
    failure_reason: syncFailureReasonSchema.optional(),
    metadata: z.record(z.unknown()).optional(),
    emitted_at: z.coerce.date().default(() => new Date()),
});
export function parseSyncRunPatch(input) {
    return syncRunPatchSchema.parse(input);
}
export function parseSyncEvent(input) {
    return syncEventSchema.parse(input);
}
//# sourceMappingURL=sync-state.js.map